import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useState } from "react";

const CommentaryViewDialog = ({ open, setOpen, commentary }) => {
  const [submited, setSubmited] = useState(false);

  const handleSubmitReject = () => {
    setOpen(false);
  };
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent sx={{ width: 400, height: "auto" }}>
        <div>
          <TextField
            fullWidth
            label="Comentario"
            multiline
            rows={4}
            maxRows={4}
            value={commentary}
            error={!commentary.length && submited}
            helperText={!commentary.length && submited ? "El campo es requerido" : " "}
          />
          <div className="w-full flex justify-between">
            <Button fullWidth color="primary" variant="outlined" onClick={handleSubmitReject} autoFocus>
              Cerrar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CommentaryViewDialog;
